import { AuthSelectors } from "src/redux/Auth/selectors";
import { MdActions } from "src/redux/MarketData/actions";
import { TxSelectors } from "src/redux/Tx/selectors";
import { RecallSelectors } from "./selectors";
import { Recall } from "./types";
import { setDateFormat } from "src/utils";
import fetchWrapper from "src/utils/fetchWrapper";
import { SpinnerActions } from "src/redux/Spinner/actions";
import { ModalActions } from "src/redux/Modal/actions";
import { TxActions } from "src/redux/Tx/actions";
import { ToasterActions } from "src/redux/Toaster/actions";

export const RecallActions = {
    SendRecallRequest: () => async (dispatch, getState) => {
        dispatch(SpinnerActions.Open());
        const state = getState();
        const requestRows = RecallSelectors.RecallRequestRows(state);
        const comment = RecallSelectors.RecallRequestComment(state);
        // Server deserialises `borrower` into a Counterparty object,
        // so we need the resolved cpty here, not just the id. Same
        // reason as the SendOffer path in Tx/actions.js.
        const borrower = TxSelectors.TxInitSelectedCptys(state)[0];
        const email = AuthSelectors.User(state).attributes.email;
        const url = AuthSelectors.BuildRecallLenderRequestUrl(state);

        const request = {
            user: { email },
            borrower,
            comment,
            txSet: requestRows.map((row) => ({
                ...row,
                security: { ...row.marketData.data },
                dueDate: setDateFormat(row.dueDate, "-"),
                settlementDate: setDateFormat(row.settlementDate, "-"),
            })),
        };

        return dispatch(
            fetchWrapper(url, {
                method: "POST",
                body: JSON.stringify(request),
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            })
        )
            .then((result) => {
                dispatch(SpinnerActions.Close());
                dispatch(TxActions.ResetInit());
                dispatch(ModalActions.CloseAll());
            })
            .catch((error) => {
                dispatch(SpinnerActions.Close());
            });
    },

    SetRecallRequestComment: (comment) => (dispatch) =>
        dispatch({
            type: Recall.SET_RECALL_REQUEST_COMMENT,
            comment,
        }),

    PrepareRecallRequest: (recallRows) => (dispatch) => {
        dispatch({
            type: Recall.SET_RECALL_REQUEST_ENTRIES,
            entries: recallRows,
        });

        dispatch({
            type: Recall.SET_RECALL_REQUEST_COMMENT,
            comment: "",
        });

        const listTicker = [...new Set(recallRows.map((row) => row.ticker))];
        dispatch(MdActions.GetMarketDataBatch(listTicker)).then((result) =>
            dispatch({
                type: Recall.ATTACH_MARKET_DATA,
                marketData: result,
                listTicker: listTicker,
            })
        );
    },
    UpdateRecallRequestRow: (rowData) => ({
        type: Recall.UPDATE_RECALL_REQUEST_ENTRY,
        rowData,
    }),
    DeleteRecallRequestRow: (rowId) => ({
        type: Recall.DELETE_RECALL_REQUEST_ENTRY,
        rowId,
    }),

    SetRecallListHasUpdate: (hasUpdate) => ({
        type: Recall.SET_RECALLS_LIST_HAS_UPDATE,
        hasUpdate,
    }),

    CancelRecalls: (recalls, reason) => (dispatch, getState) => {
        dispatch(SpinnerActions.Open());
        const state = getState();
        const email = AuthSelectors.User(state).attributes.email;
        const url = AuthSelectors.BuildRecallLenderCancelUrl(state);

        const request = {
            user: { email },
            recallCancelEntries: recalls.map((r) => ({
                id: r.recall_id,
                reason: reason,
            })),
        };

        return dispatch(
            fetchWrapper(url, {
                method: "POST",
                body: JSON.stringify(request),
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            })
        )
            .then((result) => {
                dispatch(SpinnerActions.Close());
            })
            .catch((error) => {
                dispatch(SpinnerActions.Close());
                dispatch(ToasterActions.NewError("Failed to cancel recalls"));
            });
    },

    DisputeRecalls: (recalls, reason) => (dispatch, getState) => {
        dispatch(SpinnerActions.Open());
        const state = getState();
        const email = AuthSelectors.User(state).attributes.email;
        const url = AuthSelectors.BuildRecallBorrowerDisputeUrl(state);

        const request = {
            user: { email },
            recallDisputeEntries: recalls.map((r) => ({
                id: r.recall_id,
                reason: reason,
            })),
        };

        dispatch(
            fetchWrapper(url, {
                method: "POST",
                body: JSON.stringify(request),
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            })
        )
            .then((result) => {
                dispatch(SpinnerActions.Close());
            })
            .catch((error) => {
                dispatch(SpinnerActions.Close());
                dispatch(ToasterActions.NewError("Failed to dispute recalls"));
            });
    },
};
